// Sanjay // - 25/01/25
import { axiosGet, axiosGetAuthorize, axiosPost, axiosPostAuthorize } from '../AxiosRequests';
import {
    GetMasterCompanyList,
    SelectedDatabase,
    Login,
    GetAllRoles,
    GetModulesWithPermissions,
    SavePermissions,
    GetSidebarModules,
} from '../ApiEndPoints';

export default class AuthenticationServices {

    // async adminLogin(request) {
    //     return axiosPost(AdminLogin, request);
    // }
    // async addEditAdminDetails(request) {
    //     return axiosPostAuthorize(AddEditAdminDetails, request);

    // }
    // async getRolesForAdmin(request) {
    //     return axiosGetAuthorize(GetRolesForAdmin, request);
    // }
    // async getAdminDetailList(request) {
    //     return axiosPostAuthorize(GetAdminDetailList, request);
    // }
    // async getAdminDetailById(request) {
    //     return axiosGetAuthorize(GetAdminDetailById, request);
    // }
    // async deleteAdminDetailsById(request) {
    //     return axiosPostAuthorize(DeleteAdminDetailsById, request);
    // }
    // async forgotPassword(request) {
    //     return axiosPost(ForgotPassword, request);
    // }
    // async resetPassword(request) {
    //     return axiosPost(ResetPassword, request);
    // }
    // async azureLogin(request) {
    //     return axiosPost(AzureLogin, request);
    // }
    async getMasterCompanyList(request) {
        return axiosGet(GetMasterCompanyList, request);
    }
    async selectedDatabase(request) {
        return axiosPost(SelectedDatabase, request);
    }
    async login(request) {
        return axiosPost(Login, request);
    }
    async getRoles() {
        return axiosGetAuthorize(GetAllRoles);
    }
    async getModulesWithPermissions(request) {
        return axiosGetAuthorize(GetModulesWithPermissions, request);
    }
    async savePermissions(request) {
        return axiosPostAuthorize(SavePermissions, request);
    }
    async getSidebarModules(request) {
        return axiosGetAuthorize(GetSidebarModules, request);
    }
}